import { useMemo, useEffect } from 'react'
import type { Integration } from 'entities/Integrations'

export type IIntegrationStore = {
  init: (integration: Integration) => void
  dispose?: () => void
}

export const useIntegrationStoreMemo = <
  Store extends IIntegrationStore,
  Params extends [Integration, ...unknown[]]
>(
  StoreClass: new (...args: Params) => Store,
  ...args: Params
) => {
  const memoStore = useMemo(() => new StoreClass(...args), [])
  const integration = args[0]

  useEffect(() => {
    if (['salesforce', 'agentforce'].includes(integration.key)) {
      memoStore.init(integration)

      return
    }

    if (integration.isConnected) memoStore.init(integration)
  }, [integration.isConnected])

  // unmount hook
  useEffect(
    () => () => {
      memoStore.dispose?.()
    },
    []
  )

  return memoStore
}
